import store from "@/store";

import { assignGroupName, assignAlertChannelName } from "@/libs/assignFormOptions";
import { checkDocumentExist } from "@/api/documentexist";
import { _updateData } from "@/api/esdata";

export const settingZoneExplain = (parentVue) => {
    return {
        description: "<p>Alert Rules</p>",
    };
};

export const isEnabled = (parentVue) => {
    return {
        sectionKey: "essential",
        description: "<p>Whether this rule is enabled.</p>",
        formTypes: ["createForm", "editForm"],
        render: (h, params) => {
            var statusColor = params.row.isenabled ? "success" : "default";
            var status = params.row.isenabled;
            var vm = parentVue.$refs.rcmTable;
            return h("i-switch", {
                props: {
                    trueColor: statusColor,
                    value: status,
                    beforeChange() {
                        return new Promise((resolve) => {
                            vm.$Modal.confirm({
                                title: vm.$i18n.t("rcmtable.changeStatusText"),
                                content: vm.$i18n.t("rcmtable.confirmChangeStatusText"),
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    resolve();
                                },
                            });
                        });
                    },
                    disabled: vm.isEditBtnDisabled,
                },
                on: {
                    "on-change": (value) => {
                        params.row.isenabled = value;
                        delete params.row._index;
                        delete params.row._rowKey;
                        delete params.row._checked;
                        _updateData("rcm-alertrules", "index", params.row)
                            .then((result) => {
                                vm.$Notice.success({
                                    title: vm.$i18n.t("global.success"),
                                    desc: `${result.data.message}`,
                                });
                            })
                            .catch(function (error) {
                                vm.$Notice.warning({
                                    title: vm.$i18n.t("global.error"),
                                    desc: `${error}`,
                                });
                                vm.getTableData();
                            });
                    },
                },
            });
        },
    };
};
export const ruleName = (parentVue) => {
    return {
        validate: [
            {
                required: true,
                message: "Missing RuleName",
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\-\_]*$/.test(value))
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _`));
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    checkDocumentExist({
                        topic: "alertRuleName",
                        fieldVal: value,
                        groupName: vm.formData.groupName,
                    }).then((result) => {
                        if (!result.data.success) {
                            return callback(new Error("Duplicate ruleName"));
                        }
                        callback();
                    });
                },
                trigger: "blur",
            },
        ],
    };
};



// WEBPACK FOOTER //
// ./src/view/AlertRules/fields.js